import moment from "moment";

// 譲受譲渡日の自動入力は停止したが、画面をリロードするまでは前回入力した日付を引き継いで初期値にする
let lastAssignmentDate = '';
export const setLastAssignmentDate = (value) => {
    lastAssignmentDate = value;
}

export const initialOrderPackData = (item = null,defaultParams = null) => {
    let result = {
        pharmacy_medicine_id:0,
        medicine_group_id:null,
        medicine_group_name:'',
        pharmacy:{},
        tax_total_type:0,
        amount_float_type:0,
        assignment_date:lastAssignmentDate, // 自動入力停止 20261006、前回入力値を引き継ぐ
        number:0,
        unit_price:0,
        to_pharmacy_note:'',
        medicine:{},
    }
    if (item != null) {
        result.pharmacy_medicine_id = item['id'];
    }
    if (defaultParams != null) {
        for (let key in defaultParams) {
            result[key] = defaultParams[key];
        }
    }

    return result;
}

export const initialOrderData = (item = null,defaultParams = null) => {
    let result = {
        pharmacy_medicine_id:0,
        medicine_id:0,
        wholesaler_id:0,
        wholesaler_old_id:0,
        wholesaler_name:'',
        lot_number:0,
        order_status:0,
        current_unit_price:0,
        package_unit_number:0,
        package_quantity_number:0,
        commited:false,
        is_telephone:false,
    }

    if (item != null) {
        result.pharmacy_medicine_id = item['id'];
        result.medicine_id = item['medicine_id'];
        result.wholesaler_id = item['wholesaler_id'];
        result.wholesaler_old_id = item['wholesaler_id'];
        result.wholesaler_name = item['wholesaler_name'];
        result.current_unit_price = item['current_unit_price'];
        result.package_unit_number = item['package_unit_number'];
        result.package_quantity_number = item['package_quantity_number'];
        result.order_status = item['order_status'];
        if (typeof item['pharmacy_medicine_id'] !== 'undefined') {
            result.pharmacy_medicine_id = item['pharmacy_medicine_id'];
        }
        if (typeof item['lot_number'] !== 'undefined') {
            result.lot_number = item['lot_number'];
        }
        if (typeof item['commited'] !== 'undefined') {
            result.commited = item['commited'];
        }
    }
    if (defaultParams != null) {
        for (let key in defaultParams) {
            result[key] = defaultParams[key];
        }
    }
    return result;
}

export const initialPackSubmitWaitData = (packStatus,stockId,medicineType,stockGroupId,number,pharmacyPackSubmitWaits) => {
    let record = {
        pack_status:packStatus,
        id:stockId,
        medicine_type:medicineType,
        stock_group_id:stockGroupId,
        is_submitted:false,
        is_canceled:false,
        is_error:false,
        error_message:'',
        total_number:number,
        pharmacy_pack_submit_waits:[],
    };
    for (let i=0;i<pharmacyPackSubmitWaits.length;i++) {
        record.pharmacy_pack_submit_waits.push({
            id:pharmacyPackSubmitWaits[i].id,
            medicine_id:pharmacyPackSubmitWaits[i].medicine_id,
            number:pharmacyPackSubmitWaits[i].number,
            lot_no:pharmacyPackSubmitWaits[i].lot_no,
            expire_date:pharmacyPackSubmitWaits[i].expire_date,
        })
    }
    return record;
}
